import {
  ModeratorRoutesPrivileges,
  StaffManagerPermissions
} from "modules/common";
import { Controller } from "react-hook-form";
import { SelectList } from "ui";

import { STAFF_MANAGER_PRIVILEGES_LIST } from "../../../../constants";
import { StaffManagerFormAtomPrivilegesProps } from "../StaffManagerForm.types";

const PrivilegesSelector = ({
  control
}: StaffManagerFormAtomPrivilegesProps) => {
  return (
    <Controller
      control={control}
      name="privileges"
      render={({
        field: { value: privileges, onChange: changePrivileges },
        fieldState: { error: _error }
      }) => (
        <Controller
          control={control}
          name="permissions"
          render={({
            field: { value: permissions, onChange: changePermissions },
            fieldState: { error }
          }) => (
            <SelectList
              value={[...privileges, ...permissions]}
              onChange={(value) => {
                const normalizedValue = Array.isArray(value) ? value : [value];

                const newPermissions: string[] = [];
                const newPrivileges: string[] = [];

                normalizedValue.forEach((item) => {
                  if (
                    Object.values(StaffManagerPermissions).includes(
                      item as StaffManagerPermissions
                    )
                  ) {
                    newPermissions.push(item);
                  } else if (
                    Object.values(ModeratorRoutesPrivileges).includes(
                      item as ModeratorRoutesPrivileges
                    )
                  ) {
                    newPrivileges.push(item);
                  }
                });

                changePermissions(newPermissions);
                changePrivileges(newPrivileges);
              }}
              options={STAFF_MANAGER_PRIVILEGES_LIST}
              errorMessage={error?.message}
            />
          )}
        />
      )}
    />
  );
};

export default PrivilegesSelector;
